import {
  type ToastApi,
  toastApiRef,
  useApi,
} from '@backstage/frontend-plugin-api';

export const AUTO_DISMISS_MS = 5_000;

export const useToast = (): ToastApi => useApi(toastApiRef);
